<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'paymentActionUrl.title' | translate }}</h4>
      <p class="mb-0">{{ 'paymentActionUrl.text' | translate }}</p>
    </div>
    <div class="card-body">
      <div class="px-3">
        <form class="form" #paymentActionUrlForm="ngForm" (ngSubmit)="onSubmit(paymentActionUrlForm)">
          <div class="form-body">
            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'paymentActionUrl.detailsHeader' | translate }}
            </h4>

            <!-- Id -->
            <div class="form-group d-none d-lg-block">
              <label for="PaymentActionId">{{ 'paymentActionUrl.paymentRequestIdFieldLabel' | translate }}</label>
              <input class="form-control" name="PaymentActionId" #PaymentActionId="ngModel"
                     [(ngModel)]="currentObject.Id"
                     placeholder="{{'paymentActionUrl.paymentRequestIdFieldPlaceHolder' | translate}}"
                     readonly="readonly">
            </div>

            <!-- QR Code -->
            <div class="form-group">
              <label>{{ 'paymentActionUrl.qrCodeFieldLabel' | translate }}</label>
              <qrcode class="qrcode" [qrdata]="paymentActionUrl" [width]="256" [errorCorrectionLevel]="'H'"></qrcode>
            </div>

            <h4 class="form-section">
              <i class="ft-share-2"></i> {{ 'paymentActionUrl.shareHeader' | translate }}
            </h4>

            <div class="row">
              <div class="col-3">
                <a [href]="emailUrl" class="succes" title="{{'paymentActionUrl.shareUrlByEmailTitle' | translate}}">
                  <i class="ft-mail font-medium-8"></i>
                </a>
              </div>

              <div class="col-3">
                <a [href]="smsUrl | safeUrl" class="succes"
                   title="{{'paymentActionUrl.shareUrlBySmsTitle' | translate}}">
                  <i class="ft-message-square font-medium-8"></i>
                </a>
              </div>

              <div class="col-3">
                <a [href]="whatsAppUrl | safeUrl" class="succes"
                   title="{{'paymentActionUrl.shareUrlByWhatsAppTitle' | translate}}">
                  <i class="fab fa-whatsapp-square fa-2x"></i>
                </a>
              </div>
              <div class="col-3">
                <a (click)="copyUrl(paymentActionUrl)" class="succes"
                   title="{{'paymentActionUrl.copyUrlToClipboard' | translate}}">
                  <i class="ft-copy font-medium-8"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="clear-float-left"></div>
          <div class="form-actions clear-float-left">
            <!-- Send payment request url by sms -->
            <button [hidden]="!hasSendUrlBySmsPermission || !hasDesktopView" type="button"
                    class="btn btn-primary btn-raised mr-1" (click)="sendUrlBySms()"
                    title="{{'paymentActionUrl.sendBySmsButtonTitle' | translate}}">
              <i class="ft-message-circle"></i> {{ 'buttons.sendSmsText' | translate }}
            </button>
            <!-- Send payment request url by email -->
            <button [hidden]="!hasSendUrlByEmailPermission || !hasDesktopView" type="button"
                    class="btn btn-primary btn-raised mr-1 " (click)="sendUrlByEmail()"
                    title="{{'paymentActionUrl.sendByEmailButtonTitle' | translate}}">
              <i class="ft-mail"></i> {{ 'buttons.sendEmailText' | translate }}
            </button>
            <!-- Pay direct -->
            <button [hidden]="hidePayDirect" class="btn btn-raised btn-raised btn-primary mr-1" type="submit"
                    title="{{'paymentActionUrl.payDirectButtonTitle' | translate}}">
              <i class="ft-check-square"></i> {{ 'buttons.payDirectText' | translate }}
            </button>
            <!-- Close modal -->
            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
              <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
